import gql from 'graphql-tag';
import { userPaymentFragment } from './fragments';

export const registerSourceIntentMutation = gql`
  mutation ($user_id: ID, $type: String) {
    registerSourceIntent(user_id: $user_id, type: $type) {
      client_secret
    }
  }
`;

export const createAppLoginTokenMutation = gql`
  mutation ($client_id: ID, $hostname: String) {
    createAppLoginToken(client_id: $client_id, hostname: $hostname) {
      id
      created_at
      user_id
      ttl
    }
  }
`;

export const registerSourceMutation = gql`
  mutation ($user_id: ID!, $token: String!, $type: String) {
    registerSource(
      user_id: $user_id
      token: $token
      stripe_account: VYTAL
      type: $type
    ) {
      ...UserPaymentFragment
    }
  }
  ${userPaymentFragment}
`;

export const participateInRaffleMutation = gql`
  mutation participateInRaffle(
    $raffle_campaign_id: String!
    $container_short_id: String!
    $email_address: String!
    $raffle_participant_id: String
  ) {
    participateInRaffle(
      raffle_campaign_id: $raffle_campaign_id
      container_short_id: $container_short_id
      email_address: $email_address
      raffle_participant_id: $raffle_participant_id
    ) {
      success
      raffle_participant_id
    }
  }
`;

export const registerForT2bReturnRemindersMutation = gql`
  mutation ($transaction_id: ID!, $email: String!) {
    registerForT2bReturnReminders(
      transaction_id: $transaction_id
      email: $email
    )
  }
`;
